import { Injectable } from '@angular/core';
import { HttpServices } from 'src/app/shared/services/http-service.service';
import { QualityRequestDTO } from '../models/quality-Request-DTO.model';

@Injectable({
  providedIn: 'root'
})
export class QualityRequestService {

  constructor(private http: HttpServices) { }
  addQualityRequest(qualityRequestDTO: QualityRequestDTO) {

    return this.http.post('QualityRequest/AddQualityRequest', qualityRequestDTO);
  }

  getQualityRequest(id){
    return this.http.get('QualityRequest/GetQualityRequest/'+id);
  }

}
